import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";
import { submitPartialForm } from "../../Helpers/API/formsAPI";

function TypeOfMerchant({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    merchant_type: false,
  });

  const TYPE_OF_MERCHANT_OPTIONS = [
    "Maya Merchant",
    "Non-Maya Merchant"
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      [name]: value,
    }));
    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const validateForm = () => {
    const errors = {
      merchant_type: !primaryDetails.merchant_type,
    };

    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please select a merchant type", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    return !!primaryDetails.merchant_type;
  };
  const handleNext = () => {
    if (validateForm()) {
      if (primaryDetails.merchant_type === "Maya Merchant") {
        navigation.go("maya-solution");
      } else {
        navigation.go("interested-maya-solution");
      }
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">TYPE OF MERCHANT</h4>
                <p className="form-desc">Please select whether this is a Maya merchant or non-Maya merchant</p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* Type of Merchant Question */}
                  <Form.Group className="mb-5" controlId="merchant_type">
                    <Form.Label className="form-label">
                      Type of Merchant <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {TYPE_OF_MERCHANT_OPTIONS.map((option, index) => (
                        <div
                          key={`merchant-type-${index}-${option}`}
                          className={`form-radio-item${primaryDetails.merchant_type === option ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="merchant_type"
                              value={option}
                              label={option}
                              onChange={handleInputChange}
                              checked={primaryDetails.merchant_type === option}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {isError.merchant_type && (
                      <div className="form-error">
                        Please select a merchant type
                      </div>
                    )}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default TypeOfMerchant;
